import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { buildFaqPageJsonLd } from '../SEO';

const FAQ_ITEMS = [
  {
    q: 'How does ProposAI\'s AI actually work?',
    a: 'We use GPT-5 for RFP generation and Claude Sonnet for proposal scoring. Our AI uses industry-standard procurement frameworks to generate professional RFPs quickly, understanding context, requirements, and criteria specific to your needs.',
  },
  {
    q: 'Can I customize the AI-generated RFPs?',
    a: 'Absolutely. AI creates the first draft in 2 minutes, then you can edit, add sections, or adjust criteria. You have full control over the final document while saving significant time on initial creation.',
  },
  {
    q: 'How do you ensure vendor quality?',
    a: 'Vendors create profiles with their expertise, skills, and experience. Our AI matching system connects businesses with vendors based on project requirements, skills, and fit. You maintain full control over vendor selection.',
  },
  {
    q: 'Is my data secure and confidential?',
    a: 'Yes. We use industry-standard encryption and store all data on Canadian infrastructure (PIPEDA and Quebec Law 25 compliant). Your RFPs are confidential and only visible to vendors you choose to share with.',
  },
  {
    q: 'What if I need help or have questions?',
    a: 'All plans include email support. Consultant plan subscribers get priority support with under 24-hour response times. Enterprise customers get a dedicated account manager.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes, no lock-in contracts. Cancel anytime and you\'ll have access until the end of your billing period. We\'ll help you export your data.',
  },
];

const FAQSection = () => {
  const { t } = useTranslation();

  const faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(buildFaqPageJsonLd(FAQ_ITEMS))}
        </script>
      </Helmet>
      <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              {t('landing.faq.title')}
            </h2>
          </div>

          <div className="space-y-6">
            {faqKeys.map((key) => (
              <div key={key} className="bg-white rounded-xl p-8 shadow-md border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {t(`landing.faq.${key}.question`)}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {t(`landing.faq.${key}.answer`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;
